import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { withRouter } from 'react-router-dom';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import * as actions from '../action';
import UpdateCalendarEntryModal from './UpdateCalendarEntryModal';

function Information({ data, deleteCalendarEntries, getCalendarEntriesList }) {
  const setModal = useContext(ModalContext);
  const handleDeleteClick = (info) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to delete the calendar entry for date ${
        _.get(data, 'attributes.date') || 'this item'
      } / ${_.get(data, 'attributes.title') || ''} ?`,
      () => {
        deleteCalendarEntries(info.id, () => {
          getCalendarEntriesList();
          // showCalendarEntry(_.get(data, '0.id'));
          window.location.reload();
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };
  const handleEdit = (info) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateCalendarEntryModal calendarEntryData={info} />,
      title: 'Update Calendar Entry',
      modalSize: 'modal-md',
    });
  };

  return (
    <div className="row mb-3">
      <div className="col-md-12">
        <div className="card p-2">
          <div className="row">
            <div className="col-md-12 d-flex justify-content-between align-items-center">
              <div className="font-weight-bold text-center w100">
                Information
              </div>
              {_.get(data, 'id') ? (
                <div>
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleEdit(data)}
                  >
                    <i className="far fa-edit icon-edit" />
                  </button>
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleDeleteClick(data)}
                  >
                    <i className="far fa-trash-alt icon-delete" />
                  </button>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 ">
              <div className="info-container p-4">
                <div className="row">
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="col-md-6">
                        <span className="text-muted">Title:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {_.get(data, 'attributes.title') || 'N/A'}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="col-md-6">
                        <span className="text-muted">Description:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {_.get(data, 'attributes.description') || 'N/A'}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="col-md-6">
                        <span className="text-muted">Type:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {_.get(data, 'attributes.type') || 'N/A'}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row border-bottom">
                      <div className="col-md-6">
                        <span className="text-muted">Date:</span>
                      </div>
                      <div className="col-md-6">
                        <span className="full-label">
                          {moment(_.get(data, 'attributes.date')).format(
                            'MM/DD/YYYY'
                          ) || '---'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Information.propTypes = {
  getCalendarEntriesList: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  deleteCalendarEntries: PropTypes.instanceOf(Function).isRequired,
  // showCalendarEntry: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(Information);
